export default [
  {
    name: 'Vehicle Record',
    url: '/vehicle-record',
    icon: 'icon-notebook',
    role: ['admin']
  },
  {
    name: 'Vehicle List',
    url: '/vehicle-list',
    icon: 'icon-notebook',
    role: ['admin']
  },
  {
    name: 'Workshop',
    url: '/mrs-workshops',
    icon: 'icon-notebook',
    role: ['admin']
  },
  {
    name: 'Electric Vehicles',
    url: '/electric-vehicles',
    icon: 'icon-notebook',
    role: ['admin']
  },
  {
    name: 'Electric Vehicles Config',
    url: '/electric-vehicles-config',
    icon: 'icon-notebook',
    role: ['admin']
  },
  {
    name: 'Reservations',
    url: '/reservations',
    icon: 'icon-notebook',
    role: ['admin']
  },
  {
    name: 'Fleet Event for Car Club Vehicles',
    url: '/tribecar/reservations',
    icon: 'icon-notebook',
    role: ['admin']
  },
]